import { render, staticRenderFns } from "./AppletOrder.vue?vue&type=template&id=18b17fb2&scoped=true&"
import script from "./AppletOrder.vue?vue&type=script&lang=js&"
export * from "./AppletOrder.vue?vue&type=script&lang=js&"
import style0 from "./AppletOrder.vue?vue&type=style&index=0&id=18b17fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b17fb2",
  null
  
)

export default component.exports